/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitPrivacyData } from './MonitPrivacyData';
import {
    MonitPrivacyDataFromJSON,
    MonitPrivacyDataFromJSONTyped,
    MonitPrivacyDataToJSON,
} from './MonitPrivacyData';

/**
 * 
 * @export
 * @interface MonitEntityPrivacySignalsResult
 */
export interface MonitEntityPrivacySignalsResult {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityPrivacySignalsResult
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityPrivacySignalsResult
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityPrivacySignalsResult
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityPrivacySignalsResult
     */
    asset?: string;
    /**
     * 
     * @type {MonitPrivacyData}
     * @memberof MonitEntityPrivacySignalsResult
     */
    data?: MonitPrivacyData;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityPrivacySignalsResult
     */
    found?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityPrivacySignalsResult
     */
    created?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityPrivacySignalsResult
     */
    updated?: number;
}

/**
 * Check if a given object implements the MonitEntityPrivacySignalsResult interface.
 */
export function instanceOfMonitEntityPrivacySignalsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityPrivacySignalsResultFromJSON(json: any): MonitEntityPrivacySignalsResult {
    return MonitEntityPrivacySignalsResultFromJSONTyped(json, false);
}

export function MonitEntityPrivacySignalsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityPrivacySignalsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'data': !exists(json, 'data') ? undefined : MonitPrivacyDataFromJSON(json['data']),
        'found': !exists(json, 'found') ? undefined : json['found'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
    };
}

export function MonitEntityPrivacySignalsResultToJSON(value?: MonitEntityPrivacySignalsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_domain': value.entity_domain,
        'entity_name': value.entity_name,
        'asset': value.asset,
        'data': MonitPrivacyDataToJSON(value.data),
        'found': value.found,
        'created': value.created,
        'updated': value.updated,
    };
}

